import React, { useState, useEffect, useRef } from "react";
import Header from "./Header.js";
import FilterIcon from "../assets/filterIcon.png";
import Search from "../assets/search.png";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ViewStaffPagesText,
  status_search2,
} from "./../CommonJquery/WebsiteText";
import {
  server_post_data,
  get_cars_data,
  update_last_maintenance_notes,
} from "../ServiceConnection/serviceconnection.js";
import "../Components/Css/Maintanance.css";
import {
  computeTodayDate,
  handleError,
  handleIaphabetnumberChange,
  mondayDayYearFormat,
  computeplussevendays,
  goBack,
  sortByCarTaglineAscending,
  handleSuccess,
} from "../CommonJquery/CommonJquery.js";
import { Button, Modal } from "react-bootstrap";
import { ArrowLeft } from "lucide-react";
import { CalendarClock, IdCard } from "lucide-react";
import { retrieveData } from "../LocalConnection/LocalConnection.js";
import AddNewGuestCar from "./AddNewGuestCar.js";

const MaintananceViewPage = ({ sharedValue }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const tableContainerRef = useRef(null);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [hideButtons, setHideButtons] = useState(false);
  const [statusNotes, setStatusNotes] = useState("");
  const [bookingIdToToggle, setBookingIdToToggle] = useState(null);

  let flag = "1";
  const { data } = location.state || {};
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);

  let formattedSevenDaysAgo = computeplussevendays();
  let formattedToday = computeTodayDate();
  let datataa = status_search2[0].value;
  if (data !== null && data !== undefined) {
    datataa = data;
    flag = "2";
  }
  const [flagData, setflagData] = useState(flag);
  // Set initial state using useState hook
  const [startDate, setStartDate] = useState(formattedSevenDaysAgo);
  const [endDate, setEndDate] = useState(formattedToday);
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredDataALL, setfilteredDataALL] = useState([]);
  const [selectedValue, setSelectedValue] = useState("Car Number");
  const [statusValue, setstatusValue] = useState(datataa);

  const [SearchFilter, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [mechanicCurrentPage, setMechanicCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [addIPassModalOpen, setAddIPassModalOpen] = useState(false);

  const master_data_get = async (
    start_date,
    end_date,
    flag,
    call_id,
    status_data,
    click_data
  ) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    fd.append("search_option", selectedValue);
    fd.append("status_data", status_data);
    if (!ownCarTab) {
      fd.append("car_guest_running", "guest");
    }
    await server_post_data(get_cars_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          seteditStaffData(Response.data.message.data);
          // setfilteredDataALL(Response.data.message.data);
          setFilteredData(Response.data.message.data); // Set for pagination

          setCurrentPage(1); // Reset to first page on new data
          setMechanicCurrentPage(1);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setSearchFilter(searchValue);
    const filteredDatashow = editStaffData.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredDataALL(filteredDatashow);
    setFilteredData(filteredDatashow); // Update data for pagination
    setCurrentPage(1); // Reset to first page when filtering
    setMechanicCurrentPage(1);
  };

  const [ownCarTab, setOwnCarTab] = useState(true); // default: Owned cars

  const toggleTabs = (tab) => {
    setOwnCarTab(tab === "own");
  };

  useEffect(() => {
    try {
      const selectedStatus = retrieveData("selectedStatusFilter");
      console.log(selectedStatus);

      if (selectedStatus && selectedStatus != "1" && selectedStatus != 1) {
        setstatusValue(selectedStatus);
        localStorage.removeItem("selectedStatusFilter");

        // Reset pagination when filter changes
        setCurrentPage(1);
        setMechanicCurrentPage(1);

        // Then fetch data with the new status
        const call_id = "0";
        master_data_get(
          startDate,
          endDate,
          "2", // Set flag to "2" since we're filtering
          call_id,
          selectedStatus,
          "no"
        );
      } else {
        const call_id = "0";
        master_data_get(
          startDate,
          endDate,
          flagData,
          call_id,
          statusValue,
          "no"
        );
      }

      // Add CSS to prevent body scrolling
      const style = document.createElement("style");
      style.innerHTML = `
      .cust_hist_page_link:focus {
        outline: none;
      }
    `;
      document.head.appendChild(style);

      // ✅ Clean up safely
      return () => {
        if (document.head.contains(style)) {
          document.head.removeChild(style);
        }
      };
    } catch (err) {
      console.error("Error in useEffect:", err);
    }
  }, [ownCarTab]);

  const handleCallData = () => {
    const call_id = "0";
    master_data_get(startDate, endDate, flagData, call_id, statusValue, "no");
  };

  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    SearchFilter && SearchFilter.length > 0
      ? sortByCarTaglineAscending(SearchFilter).slice(
          indexOfFirstItem,
          indexOfLastItem
        )
      : [];
  const totalPages =
    SearchFilter && SearchFilter.length > 0
      ? Math.ceil(SearchFilter.length / itemsPerPage)
      : 0;
  console.log(currentItems);
  const mechanicIndexOfLastItem = mechanicCurrentPage * itemsPerPage;
  const mechanicIndexOfFirstItem = mechanicIndexOfLastItem - itemsPerPage;
  const mechanicCurrentItems =
    sortByCarTaglineAscending(filteredDataALL) && filteredDataALL.length > 0
      ? filteredDataALL.slice(mechanicIndexOfFirstItem, mechanicIndexOfLastItem)
      : [];
  const mechanicTotalPages =
    filteredDataALL && filteredDataALL.length > 0
      ? Math.ceil(filteredDataALL.length / itemsPerPage)
      : 0;

  console.log(filteredDataALL);
  console.log(mechanicCurrentItems);

  // This function will handle page changes without scrolling the entire page
  const handlePageChange = (pageNumber) => {
    // Update the page number only
    setCurrentPage(pageNumber);
  };
  const handleMechanicPageChange = (pageNumber) => {
    // Update the page number only
    setMechanicCurrentPage(pageNumber);
  };

  // Fix 1: Modify renderPaginationButtons function to ensure consistent DOM structure
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={(e) => {
            e.preventDefault(); // Prevent default behavior
            if (currentPage > 1) {
              handlePageChange(currentPage - 1);
            }
          }}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(i);
            }}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={(e) => {
            e.preventDefault();
            if (currentPage < totalPages) {
              handlePageChange(currentPage + 1);
            }
          }}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };
  const handleStatusSelect = (event) => {
    setstatusValue(event.target.value);
    console.log(event.target.value);
    flag = "2";
    const call_id = "0";
    master_data_get(
      startDate,
      endDate,
      flag,
      call_id,
      event.target.value,
      "yes"
    );
  };

  const search_data = () => {
    flag = "2";
    const call_id = "0";
    master_data_get(startDate, endDate, flag, call_id, statusValue, "yes");
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  const handleNavigate2 = (id) => {
    navigate(`/car_maintenance_logs/${id}`);
  };
  const handleNavigate3 = (id) => {
    navigate(`/RepairLog/${id}`);
  };
  const handleNavigate4 = (id) => {
    navigate(`/OilCheckLog/${id}`);
  };
  const today = new Date().toISOString().split("T")[0];

  // Custom styles to ensure only the table scrolls
  const tableContainerStyle = {
    // maxHeight: "440px",
    overflowY: "auto",
    overflowX: "auto",
    position: "relative",
  };

  const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    zIndex: 9,
    backgroundColor: "#fff", // Add background color to prevent content showing through
  };

  const openNoteStatusModal = (Id) => {
    setNoteModalOpen(true);
    setBookingIdToToggle(Id);
    setHideButtons(true);
  };

  const toggleNewStatus = async () => {
    if (statusNotes != "") {
      let fd_from = new FormData();
      // Add Notes in Toll
      fd_from.append("car_id", bookingIdToToggle);
      fd_from.append("last_maintenance_notes", statusNotes);
      await server_post_data(update_last_maintenance_notes, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            setNoteModalOpen(false);
            handleSuccess("Note updated successfully");
            setStatusNotes("");
          }
        })
        .catch((error) => {
          console.log(error);
          setshowLoaderAdmin(false);
        });
    } else {
      alert("Please fill the notes section, It cannot be empty");
    }
  };
  return (
    <>
      <Header /> {showLoaderAdmin && <Loader />}
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <div className="pageCntn_head">
              {/* <div className="pageNameDiv">
                <div className="d-flex gap-2 align-items-center">
                  <p className="breadcrumb-item">View Maintanance</p>
                  <img
                    src={GreyArrow}
                    alt="Rapid Car Leasing"
                    style={{ height: "14px" }}
                  />
                </div>
              </div> */}
              <div className="calendertabs">
                <div className="calendertabs_container">
                  {" "}
                  <div
                    className={`calendertabsBtn ${
                      ownCarTab ? "activeCalendarTab" : ""
                    }`}
                    style={{ width: "140px" }}
                    onClick={() => toggleTabs("own")}
                  >
                    <p>Owned Cars</p>
                  </div>
                  <div
                    className={`calendertabsBtn ${
                      !ownCarTab ? "activeCalendarTab" : ""
                    }`}
                    style={{ width: "140px" }}
                    onClick={() => toggleTabs("new")}
                  >
                    <p>New/Guest Cars</p>
                  </div>
                </div>
              </div>
              <div className="ipass-actions d-flex flex-column flex-sm-row gap-2 mt-3 mt-md-0">
                <button
                  className="btn btn-primary ipass-btn-icon"
                  style={{ fontSize: "14px" }}
                  onClick={() => setAddIPassModalOpen(true)}
                >
                  Add New/Guest Car
                </button>
                <Button
                  onClick={goBack}
                  startIcon={
                    <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                  }
                  className="Back_bttn_page"
                  style={{
                    backgroundColor: "transparent",
                    color: "var(--primary-color)",
                  }}
                >
                  Back
                </Button>
              </div>
            </div>

            <div className="page_body">
              <div className="reservationHistory">
                <div className="viewStaff_head">
                  <div className="row m-0">
                    <div className="col-sm-3 bottomAlgin">
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={FilterIcon} alt="Rapid Car Leasing" />
                        </label>
                        <select
                          id="selectFilter"
                          onChange={handleStatusSelect}
                          value={statusValue}
                        >
                          {status_search2.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}{" "}
                            </option>
                          ))}{" "}
                        </select>
                      </div>
                    </div>

                    <div
                      className="mt-3 col-sm-3"
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        flexDirection: "row",
                        marginLeft: "auto",
                        marginRight: "0",
                      }}
                    >
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={Search} alt="Rapid Car Leasing" />
                        </label>
                        <input
                          type="text"
                          placeholder={
                            ViewStaffPagesText.Staff_Filter_reservation
                          }
                          onInput={handleIaphabetnumberChange}
                          value={searchfilter}
                          onChange={handleSearch}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="reservationHistoryTable managerTable">
                  {/* Apply fixed height and enable scroll only for table container */}
                  <div
                    ref={tableContainerRef}
                    className="historyTableContainer"
                    style={tableContainerStyle}
                  >
                    <table className="table mainViewTBL maringTopClss height_clss_body">
                      <thead
                        className="stickyHeaderClss"
                        style={stickyHeaderStyle}
                      >
                        <tr>
                          <th scope="col" className="fontWeight600 text-black">
                            Sr.No.
                          </th>
                          <th scope="col" className="fontWeight600 text-black">
                            Vehicle Details
                          </th>
                          <th scope="col" className="fontWeight600 text-black">
                            Dates
                          </th>
                          <th scope="col" className="fontWeight600 text-black">
                            Registration & Inspection Expiry
                          </th>

                          <th scope="col ">
                            <p className="actionTxtTBlHead fontWeight600 text-black">
                              {" "}
                              Action
                            </p>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="custum_border">
                        {currentItems.length > 0 ? (
                          currentItems.map((option, index) => (
                            <tr
                              className="historyTableRow"
                              style={{ height: "140px" }}
                              key={index}
                            >
                              <td>
                                <div
                                  style={{
                                    marginLeft: "1rem",
                                    fontSize: "14px",
                                    marginTop: "1.2rem",
                                    color: "#313131",
                                  }}
                                >
                                  {indexOfFirstItem + index + 1}{" "}
                                </div>
                              </td>
                              <td>
                                <div className="topMargin historyTime">
                                  <div className="historyTimeImgText">
                                    <div className="car_detail_Section">
                                      {" "}
                                      <p
                                        className="mb-0"
                                        style={{ color: "#313131" }}
                                      >
                                        <span>{option.car_tagline}</span>
                                      </p>
                                      <p className="mb-0">
                                        <span>{option.car_name}</span>
                                      </p>
                                      <p className="mb-0">
                                        <span>{option.car_no}</span>
                                      </p>
                                      <p className="mb-0">
                                        <span>{option.vin}</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="historyTableRowText historyStatus">
                                  <>
                                    <p>
                                      Last Main date:{" "}
                                      {option.last_maintenance_date !==
                                        null && (
                                        <>
                                          {mondayDayYearFormat(
                                            option.last_maintenance_date
                                          )}
                                        </>
                                      )}{" "}
                                    </p>
                                    <p>
                                      Schedule date:{" "}
                                      {option.next_maintenance_date !==
                                        null && (
                                        <>
                                          {mondayDayYearFormat(
                                            option.next_maintenance_date
                                          )}
                                        </>
                                      )}{" "}
                                    </p>
                                    <p>
                                      Overdue:{" "}
                                      {option.next_maintenance_date !==
                                        null && (
                                        <>
                                          {(() => {
                                            const today = new Date();
                                            const scheduleDate = new Date(
                                              option.next_maintenance_date
                                            );
                                            const diffTime =
                                              today - scheduleDate;
                                            const diffDays = Math.floor(
                                              diffTime / (1000 * 60 * 60 * 24)
                                            );
                                            return diffDays > 0
                                              ? `${diffDays} days`
                                              : "No";
                                          })()}
                                        </>
                                      )}
                                    </p>
                                  </>
                                </div>
                              </td>
                              <td>
                                <div className="historyTableRowText historyPerson">
                                  <div>
                                    <IdCard
                                      className="tble_icon"
                                      strokeWidth={1.5}
                                    />
                                    <p>
                                      Reg:{" "}
                                      {ownCarTab
                                        ? mondayDayYearFormat(
                                            option.registration_date
                                          )
                                        : "NA"}
                                    </p>
                                  </div>
                                  <div>
                                    <CalendarClock
                                      className="tble_icon"
                                      strokeWidth={1.5}
                                    />
                                    <p>
                                      Inspect:{" "}
                                      {ownCarTab ? option.inspection : "NA"}
                                    </p>
                                  </div>
                                  <div>
                                    <CalendarClock
                                      className="tble_icon"
                                      strokeWidth={1.5}
                                    />
                                    <p>
                                      Emission:{" "}
                                      {ownCarTab
                                        ? mondayDayYearFormat(
                                            option.emissions_due
                                          )
                                        : "NA"}{" "}
                                    </p>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div
                                  className="historyTableRowText historyPerson d-flex flex-row"
                                  style={{ gap: "0.4rem" }}
                                >
                                  <div className="mintance_action">
                                    <div
                                      style={{
                                        flexDirection: "row",
                                        display: "flex",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleNavigate(
                                            `/mainatanance_form/${option.primary_id}`
                                          )
                                        }
                                        style={{
                                          background: "#0A99FE",
                                          color: "white",
                                          zIndex: "0",
                                          width: "140px",
                                        }}
                                      >
                                        Maintanance
                                      </button>
                                      <button
                                        className="log_bttn"
                                        type="button"
                                        onClick={() =>
                                          handleNavigate2(option.primary_id)
                                        }
                                        style={{
                                          width: "140px",
                                        }}
                                      >
                                        Maintanance Logs
                                      </button>
                                    </div>
                                    <div
                                      style={{
                                        flexDirection: "row",
                                        display: "flex",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleNavigate(
                                            `/repair_form/${option.primary_id}`
                                          )
                                        }
                                        style={{
                                          background: "#0A99FE",
                                          color: "white",
                                          zIndex: "0",
                                          width: "140px",
                                        }}
                                      >
                                        Repair
                                      </button>
                                      <button
                                        className="repair_log_bttn log_bttn"
                                        type="button"
                                        onClick={() =>
                                          handleNavigate3(option.primary_id)
                                        }
                                        style={{
                                          width: "140px",
                                        }}
                                      >
                                        Repair Logs
                                      </button>
                                    </div>
                                    <div
                                      style={{
                                        flexDirection: "row",
                                        display: "flex",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleNavigate(
                                            `/oil_check_form/${option.primary_id}`
                                          )
                                        }
                                        style={{
                                          background: "#0A99FE",
                                          color: "white",
                                          zIndex: "0",
                                          width: "140px",
                                        }}
                                      >
                                        Oil Check
                                      </button>
                                      <button
                                        className="repair_log_bttn log_bttn"
                                        type="button"
                                        onClick={() =>
                                          handleNavigate4(option.primary_id)
                                        }
                                        style={{
                                          width: "140px",
                                        }}
                                      >
                                        Oil Check Logs
                                      </button>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      flexDirection: "row",
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }}
                                    className="mintance_action2"
                                  >
                                    <button
                                      type="button"
                                      onClick={() =>
                                        openNoteStatusModal(option.primary_id)
                                      }
                                      style={{
                                        background: "var(--border-color)",
                                        color: "var(--secondary-text)",
                                        zIndex: "0",
                                        width: "140px",
                                      }}
                                    >
                                      Add Note
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={5} className="text_align_center">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination controls moved outside the scrollable table area */}
                  <div className="cust_hist_card_footer">
                    <div className="cust_hist_pagination_info">
                      {SearchFilter && SearchFilter.length > 0 ? (
                        <>
                          Showing{" "}
                          <span className="cust_hist_pagination_bold">
                            {indexOfFirstItem + 1}
                          </span>{" "}
                          to{" "}
                          <span className="cust_hist_pagination_bold">
                            {Math.min(indexOfLastItem, SearchFilter.length)}
                          </span>{" "}
                          of{" "}
                          <span className="cust_hist_pagination_bold">
                            {SearchFilter.length}
                          </span>{" "}
                          Vehicles
                        </>
                      ) : (
                        <>
                          Showing{" "}
                          <span className="cust_hist_pagination_bold">0</span>{" "}
                          vehicle
                        </>
                      )}
                    </div>
                    <div className="cust_hist_pagination">
                      <nav aria-label="Pagination">
                        <ul className="cust_hist_pagination_list">
                          {renderPaginationButtons()}
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>

                <div className="reservationHistoryTable margin_tbl mechanicTable">
                  <div className="historyTableContainer stickyTableheigh274">
                    <table className="table mainViewTBL maringTopClss mechanicTable">
                      <thead
                        className="stickyHeaderClss"
                        style={{ zIndex: "9" }}
                      >
                        <tr>
                          <th scope="col" className="fontWeight600 text-black">
                            Sr.No.
                          </th>
                          <th scope="col" className="fontWeight600 text-black">
                            Vehicle Details
                          </th>
                          <th scope="col" className="fontWeight600 text-black">
                            Maintenance Date
                          </th>
                          <th scope="col">
                            <p className="actionTxtTBlHead fontWeight600 text-black">
                              Action
                            </p>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="custum_border">
                        {currentItems.length > 0 ? (
                          currentItems.map((option, index) => (
                            <tr
                              className="historyTableRow"
                              // style={{ height: "140px" }}
                              key={index}
                            >
                              <td>
                                <div
                                  style={{
                                    marginLeft: "1rem",
                                    fontSize: "14px",
                                    marginTop: "1.2rem",
                                  }}
                                >
                                  {mechanicIndexOfFirstItem + index + 1}{" "}
                                </div>
                              </td>
                              <td>
                                <div className="topMargin historyTime">
                                  {/* <p>{mondayDayYearFormat(option.entry_date)}</p> */}
                                  <div className="historyTimeImgText">
                                    <div className="historyTimeImgText">
                                      <div className="car_detail_Section">
                                        <p className="mb-0">
                                          <span>{option.car_tagline}</span>{" "}
                                        </p>
                                        <p className="mb-0">
                                          <span>{option.car_name}</span>{" "}
                                        </p>
                                        <p className="mb-0">
                                          <span>{option.car_no}</span>{" "}
                                        </p>
                                        <p className="mb-0">
                                          <span>{option.vin}</span>{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <td>
                                <div className="historyTableRowText historyStatus">
                                  <p>
                                    Schedule date:{" "}
                                    {option.next_maintenance_date !== null && (
                                      <>
                                        {mondayDayYearFormat(
                                          option.next_maintenance_date
                                        )}
                                      </>
                                    )}{" "}
                                  </p>
                                </div>
                              </td>

                              <td>
                                <div
                                  className="historyTableRowText historyPerson d-flex flex-row"
                                  style={{ gap: "0.4rem" }}
                                >
                                  <div className="mintance_action">
                                    <div
                                      style={{
                                        flexDirection: "row",
                                        display: "flex",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleNavigate(
                                            `/mainatanance_form/${option.primary_id}`
                                          )
                                        }
                                        style={{
                                          background: "#0A99FE",
                                          color: "white",
                                          zIndex: "0",
                                          width: "140px",
                                        }}
                                      >
                                        Maintanance
                                      </button>
                                    </div>
                                    <div
                                      style={{
                                        flexDirection: "row",
                                        display: "flex",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleNavigate(
                                            `/repair_form/${option.primary_id}`
                                          )
                                        }
                                        style={{
                                          background: "#0A99FE",
                                          color: "white",
                                          zIndex: "0",
                                          width: "140px",
                                        }}
                                      >
                                        Repair
                                      </button>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      flexDirection: "column",
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }}
                                    className="mintance_action2"
                                  >
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleNavigate(
                                          `/oil_check_form/${option.primary_id}`
                                        )
                                      }
                                      style={{
                                        background: "#0A99FE",
                                        color: "white",
                                        zIndex: "0",
                                        width: "140px",
                                      }}
                                    >
                                      OilCheck
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        openNoteStatusModal(option.primary_id)
                                      }
                                      style={{
                                        background: "var(--border-color)",
                                        color: "var(--secondary-text)",
                                        zIndex: "0",
                                        width: "140px",
                                      }}
                                    >
                                      Add Note
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={5} className="text_align_center">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <div className="cust_hist_card_footer">
                      <div className="cust_hist_pagination_info mechanicTable">
                        {SearchFilter && SearchFilter.length > 0 ? (
                          <>
                            Showing{" "}
                            <span className="cust_hist_pagination_bold">
                              {indexOfFirstItem + 1}
                            </span>{" "}
                            to{" "}
                            <span className="cust_hist_pagination_bold">
                              {Math.min(indexOfLastItem, SearchFilter.length)}
                            </span>{" "}
                            of{" "}
                            <span className="cust_hist_pagination_bold">
                              {SearchFilter.length}
                            </span>{" "}
                            Vehicles
                          </>
                        ) : (
                          <>
                            Showing{" "}
                            <span className="cust_hist_pagination_bold">0</span>{" "}
                            vehicle
                          </>
                        )}
                      </div>
                      <div className="cust_hist_pagination">
                        <nav aria-label="Pagination">
                          <ul className="cust_hist_pagination_list">
                            {renderPaginationButtons()}
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Car Maintanance add note assign modal */}
      <Modal
        show={noteModalOpen}
        onHide={() => setNoteModalOpen(false)}
        className="ipass-modal"
        centered
      >
        <Modal.Header
          style={{ backgroundColor: "var(--primary-color)" }}
          closeButton
        >
          <Modal.Title style={{ color: "#fff" }}>
            Add Note for Maintance
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="assignForm">
            <div className="mb-3">
              <label
                htmlFor="assignmentNotes"
                className="form-label ipass-form-label"
              >
                Notes
              </label>
              <textarea
                id="assignmentNotes"
                name="notes"
                rows="3"
                className="form-control"
                placeholder="Add any additional information about this assignment"
                onChange={(e) => setStatusNotes(e.target.value)}
              ></textarea>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setNoteModalOpen(false)}>
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "var(--primary-color)",
              border: "none",
              color: "#ffffff",
            }}
            onClick={() => toggleNewStatus()}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Add New Guest Car Modal */}
      <AddNewGuestCar
        addIPassModalOpen={addIPassModalOpen}
        setAddIPassModalOpen={setAddIPassModalOpen}
        handleCallData={handleCallData}
      />
    </>
  );
};

export default MaintananceViewPage;
